import { Flex, Table, TableColumnsType, TablePaginationConfig } from 'antd';
import { ContentInterface } from 'content/library/types/contentType';
import React, { useEffect, useState } from 'react';
import { playlistContentListService } from '../services/playlistContentListService';
interface PlaylistVideosProps {
  id: string;
}
export const PlaylistVideos: React.FC<PlaylistVideosProps> = ({ id }) => {
  const [playlistContents, setPlaylistContents] = useState<ContentInterface[]>([]);
  const [pagination, setPagination] = useState<TablePaginationConfig>({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const dataFetch = async (): Promise<void> => {
    const data = await playlistContentListService.fetch(
      new URLSearchParams({
        page: pagination.current?.toString() || '1',
        page_size: pagination.pageSize?.toString() || '10',
        playlist_id: id!,
      })
    );
    setPlaylistContents(data.results);
    setPagination({
      ...pagination,
      total: data.count,
    });
  };

  const columns: TableColumnsType<ContentInterface> = [
    {
      dataIndex: 'id',
      title: 'ID',
      width: '5%',
    },
    {
      dataIndex: 'title',
      title: 'Title',
      width: '20%',
      render: (_, record): React.ReactNode => {
        return (
          <Flex align="center" gap="small">
            <span>{record.title}</span>
          </Flex>
        );
      },
    },
    {
      title: 'THUMBNAIL',
      dataIndex: 'thumbnail',
      key: 'thumbnail',
      width: '10%',
      render: (_text: string, record: ContentInterface) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img
            style={{ marginLeft: '10px', width: '100%', height: 'auto' }}
            src={record.thumbnail?.file ?? ''}
            alt=""
          />
        </div>
      ),
    },
    {
      dataIndex: 'created',
      title: 'Created',
      width: '5%',
    },
  ];

  useEffect(() => {
    dataFetch();
  }, [pagination.current, pagination.pageSize]);

  return (
    <div>
      <Table
        rowKey="id"
        columns={columns}
        dataSource={playlistContents}
        pagination={pagination}
        onChange={(pagination, _filters, _sorter) => {
          setPagination(pagination);
        }}
      />
    </div>
  );
};
